import React from "react";

function About() {
  return (
    <div>
      <section className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">Hakkımızda</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Ana Sayfa</a>
                  </li>
                  <li className="breadcrumb-item text-white active" aria-current="page">
                    Hakkımızda
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s" style={{ minHeight: 400 }}>
              <div className="position-relative h-100">
                <img className="img-fluid position-absolute w-100 h-100" src="assets/img/about.jpg" alt="" style={{ objectFit: "cover" }} />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6 className="section-title bg-white text-start text-primary pe-3">Hakkımızda</h6>
              <h1 className="mb-4">
                <span className="text-primary">Tourist</span>'e Hoş Geldiniz
              </h1>
              <p className="mb-4">Geçici olarak elit tekrar çökmekte. Ağrı acı ağrı ipsum oturuyor. Farklı elit diam ve eos. Clita elit ipsum ve lorem ve oturuyor.</p>
              <p className="mb-4">Geçici olarak elit tekrar çökmekte. Ağrı acı ağrı ipsum oturuyor. Farklı elit diam ve eos. Clita elit ipsum ve lorem ve oturuyor, ama stet lorem oturuyor clita ikili sadece büyük ağrı elit amet.</p>
              <div className="row gy-2 gx-4 mb-4">
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Birinci Sınıf Uçuşlar
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    Özenle Seçilmiş Oteller
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />5 Yıldızlı Konaklamalar
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    En Yeni Model Araçlar
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    150 Premium Şehir Turu
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-0">
                    <i className="fa fa-arrow-right text-primary me-2" />
                    7/24 Hizmet
                  </p>
                </div>
              </div>
              <a className="btn btn-primary py-3 px-5 mt-2" href="">
                Daha Fazla Oku
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">Seyahat Rehberi</h6>
            <h1 className="mb-5">Rehberimizle Tanışın</h1>
          </div>
          <div className="row g-4">
            {["1", "2", "3", "4"].map((num, index) => (
              <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`} key={num}>
                <div className="team-item">
                  <div className="overflow-hidden">
                    <img className="img-fluid" src={`assets/img/team-${num}.jpg`} alt="" />
                  </div>
                  <div className="position-relative d-flex justify-content-center" style={{ marginTop: "-19px" }}>
                    <a className="btn btn-square mx-1" href="">
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a className="btn btn-square mx-1" href="">
                      <i className="fab fa-twitter" />
                    </a>
                    <a className="btn btn-square mx-1" href="">
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                  <div className="text-center p-4">
                    <h5 className="mb-0">Tam Ad</h5>
                    <small>Unvan</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
